import { useLocation } from 'react-router-dom';

export const useShouldInvertNavbar = () => {
    const { pathname } = useLocation();
    const pathnames = ['/elcid', '/elcid/', '/elcid-word-lid', '/elcid-word-lid/'];

    const shouldInvertNavbar = pathnames?.includes(pathname);

    return { shouldInvertNavbar };
};